import React, { useEffect, useState } from 'react'
import { FaTrashCan } from 'react-icons/fa6'
import { MdOutlineKeyboardAlt, MdOutlineBorderColor } from "react-icons/md"
import CircularProgress from '@mui/material/CircularProgress';
import nodata from '../assets/images/nodata.webp'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { deleteMaintenance, fetchMaintenances, setCurrentPage } from '../reducers/MaintenanceSlice';
import moment from 'moment';
const Maintenance = () => {
  const dispatch = useDispatch()
  const [openDialog, setOpenDialog] = useState(false)
  const [maintenanceToDelete, setMaintenanceToDelete] = useState(null)
  const [searchQuery, setSearchQuery] = useState("");
  const { maintenances, totalPages, totalMaintenances, currentPage, status } = useSelector(state => state.maintenances)

  useEffect(() => {
    dispatch(fetchMaintenances({ page: currentPage, searchQuery }));
  }, [dispatch, currentPage, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      dispatch(setCurrentPage(newPage))
    }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setMaintenanceToDelete(null)
  }

  const handleDeleteClick = (maintenanceId) => {
    setMaintenanceToDelete(maintenanceId)
    setOpenDialog(true)
  }

  const handleConfirmDelete = async () => {
    if (maintenanceToDelete) {
      try {
        await dispatch(deleteMaintenance(maintenanceToDelete)).unwrap();
        await dispatch(fetchMaintenances({ page: currentPage, searchQuery: '' }));
        toast.success('Maintenance deleted successfully!');
      } catch (error) {
        toast.error('Failed to delete the Maintenance. Please try again.');
      } finally {
        setOpenDialog(false);
        setMaintenanceToDelete(null);
      }
    }
  };
  return (
    <>
      <div className='student-container'>
        <div className="table-header d-flex justify-content-between align-items-center p-2">
          <div className="total-count">
            <h6 className='mb-0'>Total Maintenances ({totalMaintenances})</h6>
          </div>
          <div className="search-box">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="add-btn">
            <Link to={"/maintenances/add-maintenances"}><button className="btn btn-primary text-white p-1">Add New</button></Link>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sr #</th>
                <th scope="col">Title</th>
                <th scope="col">Total Cost</th>
                <th scope="col">Status</th>
                <th scope="col">Paid By</th>
                <th scope="col">Date</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {status === 'loading' ? (
                <tr>
                  <td colSpan="6" className="loading-container">
                    <CircularProgress />
                  </td>
                </tr>
              ) : maintenances?.length > 0 ? (
                maintenances.map((maintenance, index) => (
                  <tr key={maintenance._id}>
                    <td scope="row">{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{maintenance.title}</td>
                    <td>{maintenance.totalCost}</td>
                    <td>{maintenance.status}</td>
                    <td>{maintenance.paidBy}</td>
                   <td>{moment(maintenance?.workStartDate).format('YYYY-MM-DD')}</td>
                    <td className="action-flex">
                      <Link to={`/maintenances/view-maintenance/${maintenance._id}`}>
                        <MdOutlineKeyboardAlt className="keyboard" />
                      </Link>
                      <Link to={`/maintenances/edit-maintenance/${maintenance._id}`}>
                        <MdOutlineBorderColor className="edit" />
                      </Link>
                      <FaTrashCan className="delete" onClick={() => handleDeleteClick(maintenance._id)} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-data">
                    <img src={nodata} alt="No Data" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pagination-1 d-flex justify-content-center gap-3 align-items-center">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1 || status === 'loading'}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>
        <div className="page-info">
          Page {currentPage} of {totalPages}
        </div>
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || status === 'loading'}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this Maintenance Data?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
          <Button onClick={handleConfirmDelete} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Maintenance
